import { TransferOrdersActionTypes } from "./constants";

const INIT_STATE = {
  list: [] as any[],
  total: 0,
  one: null as any,
  loading: false,
  deleting: false,
  deleted: false,
  error: null as any,
  createError: null as any,
  created: false,
  statusUpdated: false,
};

const TransferOrders = (state = INIT_STATE, action: any) => {
  switch (action.type) {

    case TransferOrdersActionTypes.GET_LIST:
      return { ...state, loading: true, error: null, created: false, deleted: false };
    case TransferOrdersActionTypes.GET_LIST_SUCCESS:
      return { ...state, loading: false, list: action.payload.items, total: action.payload.total };
    case TransferOrdersActionTypes.GET_LIST_ERROR:
      return { ...state, loading: false, error: action.payload };

    case TransferOrdersActionTypes.CREATE:
      return { ...state, loading: true, createError: null, created: false, one: null };
    case TransferOrdersActionTypes.CREATE_SUCCESS:
      return { ...state, loading: false, one: action.payload, created: true };
    case TransferOrdersActionTypes.CREATE_ERROR:
      return { ...state, loading: false, createError: action.payload };

    case TransferOrdersActionTypes.GET_ONE:
      return { ...state, loading: !state.one, error: null, statusUpdated: false };
    case TransferOrdersActionTypes.GET_ONE_SUCCESS:
      return { ...state, loading: false, one: action.payload };
    case TransferOrdersActionTypes.GET_ONE_ERROR:
      return { ...state, loading: false, error: action.payload };

    case TransferOrdersActionTypes.UPDATE:
      return { ...state, loading: true, error: null };
    case TransferOrdersActionTypes.UPDATE_SUCCESS:
      return { ...state, loading: false, one: action.payload };
    case TransferOrdersActionTypes.UPDATE_ERROR:
      return { ...state, loading: false, error: action.payload };

    case TransferOrdersActionTypes.UPDATE_STATUS:
      return { ...state, loading: true, statusUpdated: false, error: null };
    case TransferOrdersActionTypes.UPDATE_STATUS_SUCCESS:
      return { ...state, loading: false, one: action.payload, statusUpdated: true };
    case TransferOrdersActionTypes.UPDATE_STATUS_ERROR:
      return { ...state, loading: false, error: action.payload };

    case TransferOrdersActionTypes.DELETE:
      return { ...state, deleting: true, deleted: false, error: null };
    case TransferOrdersActionTypes.DELETE_SUCCESS:
      return { ...state, deleting: false, deleted: true };
    case TransferOrdersActionTypes.DELETE_ERROR:
      return { ...state, deleting: false, deleted: false, error: action.payload };

    default:
      return state;
  }
};

export default TransferOrders;
